import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/asklogo.png'
import _imports_1 from '@/assets/img/menu/asklogo_slide.png'
import _imports_2 from '../../assets/img/tabbar/user.png'


const _withScopeId = n => (_pushScopeId("data-v-f6b46422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "df both-side vertical" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  style: {"display":"block"}
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "df vertical" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "df vertical title-text" }, null, -1))
const _hoisted_6 = { class: "tool df vertical" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bread_crumb = _resolveComponent("bread-crumb")!
  const _component_notice_bell = _resolveComponent("notice-bell")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["logo df vertical df-center logobox width-transition", _ctx.props.collapsed ? 'logo-slide' : ''])
      }, [
        (!_ctx.props.collapsed)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", _hoisted_3))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["top df both-side vertical width-transition", _ctx.props.collapsed ? 'top-slide' : ''])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_bread_crumb)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_notice_bell),
          _createElementVNode("div", null, _toDisplayString(_ctx.username), 1),
          _createVNode(_component_a_dropdown, {
            placement: "bottomCenter",
            class: "user mr"
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { onClick: _ctx.logout }, {
                    default: _withCtx(() => [
                      _createTextVNode("退出")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.user.id !== 119)
                    ? (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: 0,
                        onClick: _ctx.changePasswordModal
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 修改密码 ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_avatar, null, {
                icon: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.formData.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.visible) = $event)),
      title: "修改密码",
      maskClosable: !_ctx.forceStatus,
      closable: !_ctx.forceStatus,
      cancelButtonProps: {
      disabled: _ctx.forceStatus
    },
      onOk: _ctx.changePassword,
      onCancel: _ctx.cancelChangePawword
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "newPassword",
              label: "密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.formData.newPassword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.newPassword) = $event)),
                  type: "password",
                  placeholder: "请输入8-20个字符(字母、数字或标点符号至少包含两种)"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "maskClosable", "closable", "cancelButtonProps", "onOk", "onCancel"])
  ], 64))
}